import React from 'react'
import DrawingCanvas from './DrawingCanvas'

class DrawingCanvasItem extends React.Component {
  onClickHandler = () => {
    if (!this.props.drawingSquare) {
      this.props.onClickHandler(this.props.id)
    }
  }

  shouldComponentUpdate(nextProps) {
    if (JSON.stringify(nextProps.drawingSquare) !== JSON.stringify(this.props.drawingSquare)) {
      return true
    }
    if (JSON.stringify(nextProps.style) !== JSON.stringify(this.props.style)) {
      return true
    }
    return nextProps.className !== this.props.className
  }

  render() {
    const { style, className, drawingSquare, squaresCount, zoom, drawingMode } = this.props

    return (
      <div style={style} className={className} onClick={this.onClickHandler}>
        {drawingSquare ? (
          <DrawingCanvas
            squaresCount={squaresCount}
            drawingSquareId={drawingSquare.user_drawing}
            zoom={zoom}
            drawingMode={drawingMode}
          />
        ) : null}
      </div>
    )
  }
}

export default DrawingCanvasItem



// WEBPACK FOOTER //
// ./src/components/DrawingCanvasItem.js